// Copyright (C) dātma, inc™ - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
import getEnv from '@/utils/env'

const pathologyViewerRoute = getEnv('VUE_APP_PATHOLOGY_VIEWER_ROUTE') || '/pathds/viewer/v1/mypatient'

export const initToolsUPennPayload = {
  'admin': {
    '18c09bef-eb11-4ac8-828d-647842df4973': {
      'id': '18c09bef-eb11-4ac8-828d-647842df4973',
      'width': 6,
      'height': 10,
      'name': {
        'en_US.UTF-8': 'EHR Edit Patient',
        'fr_CA.UTF-8': 'EHR Edit Patient - TBD',
        'tr_TR.UTF-8': 'EHR Edit Patient - TBD',
        'zh_CN.UTF-8': 'EHR Edit Patient - TBD',
        'zh_TW.UTF-8': 'EHR Edit Patient - TBD',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': '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',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {
        },
        'url': {
          'baseUrl': 'http://localhost:8000/',
          'method': 'GET',
          'queryParams': {
            'patientId': {
              'key': 'patientId',
              'required': false,
            },
          },
        },
      },
    },
  },
  'mypatient-full-access': {
    'e2be817e-ae40-41c9-850e-fe43c1b300ab': {
      'id': 'e2be817e-ae40-41c9-850e-fe43c1b300ab',
      'name': {
        'en_US.UTF-8': 'Tumor Board Patient Selector',
        'fr_CA.UTF-8': 'Tumor Board Patient Selector - TBD',
        'tr_TR.UTF-8': 'Tumor Board Patient Selector - TBD',
        'zh_CN.UTF-8': 'Tumor Board Patient Selector - TBD',
        'zh_TW.UTF-8': 'Tumor Board Patient Selector - TBD',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': '',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {},
        'url': {
          'baseUrl': '/tumorBoardSelector',
          'method': 'GET',
          'queryParams': {
          },
        },
      },
    },
    'e2be817e-ae40-41c9-850e-fe43c1b300bc': {
      'id': 'e2be817e-ae40-41c9-850e-fe43c1b300bc',
      'name': {
        'en_US.UTF-8': 'Report Manager',
        'fr_CA.UTF-8': 'Gestionnaire de rapports',
        'tr_TR.UTF-8': 'Rapor Yöneticisi',
        'zh_CN.UTF-8': '报告经理',
        'zh_TW.UTF-8': '報告經理',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48IS0tISBGb250IEF3ZXNvbWUgUHJvIDYuMy4wIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlIChDb21tZXJjaWFsIExpY2Vuc2UpIENvcHlyaWdodCAyMDIzIEZvbnRpY29ucywgSW5jLiAtLT48cGF0aCBkPSJNMTQ0IDk2YzAtOC44IDcuMi0xNiAxNi0xNkg0MTZjOC44IDAgMTYgNy4yIDE2IDE2VjI5My41YzAgNC4yLTEuNyA4LjMtNC43IDExLjNsLTU4LjUgNTguNWMtMyAzLTcuMSA0LjctMTEuMyA0LjdIMTYwYy04LjggMC0xNi03LjItMTYtMTZWOTZ6TTk2IDk2VjM1MmMwIDM1LjMgMjguNyA2NCA2NCA2NEgzNTcuNWMxNyAwIDMzLjMtNi43IDQ1LjMtMTguN2w1OC41LTU4LjVjMTItMTIgMTguNy0yOC4zIDE4LjctNDUuM1Y5NmMwLTM1LjMtMjguNy02NC02NC02NEgxNjBjLTM1LjMgMC02NCAyOC43LTY0IDY0em0xNzYgMzJjLTguOCAwLTE2IDcuMi0xNiAxNnY0OEgyMDhjLTguOCAwLTE2IDcuMi0xNiAxNnYzMmMwIDguOCA3LjIgMTYgMTYgMTZoNDh2NDhjMCA4LjggNy4yIDE2IDE2IDE2aDMyYzguOCAwIDE2LTcuMiAxNi0xNlYyNTZoNDhjOC44IDAgMTYtNy4yIDE2LTE2VjIwOGMwLTguOC03LjItMTYtMTYtMTZIMzIwVjE0NGMwLTguOC03LjItMTYtMTYtMTZIMjcyem0yNCAzMzZIMTM2Yy00OC42IDAtODgtMzkuNC04OC04OGwwLTIyNGMwLTEzLjMtMTAuNy0yNC0yNC0yNHMtMjQgMTAuNy0yNCAyNFYzNzZjMCA3NS4xIDYwLjkgMTM2IDEzNiAxMzZIMjk2YzEzLjMgMCAyNC0xMC43IDI0LTI0cy0xMC43LTI0LTI0LTI0eiIvPjwvc3ZnPg==',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {},
        'url': {
          'baseUrl': '/ehr_crud/mypatient/v1/',
          'method': 'GET',
          'queryParams': {
            'patientIds': { 'key': 'patient_identifier', 'required': true },
          },
        },
      },
    },
    'e2be817e-ae40-41c9-850e-hq91b6f876jh': {
      'id': 'e2be817e-ae40-41c9-850e-hq91b6f876jh',
      'name': {
        'en_US.UTF-8': 'Tumor Board Scheduler',
        'fr_CA.UTF-8': 'Planificateur du conseil des tumeurs',
        'tr_TR.UTF-8': 'Tümör Panosu Zamanlayıcısı',
        'zh_CN.UTF-8': '肿瘤板调度器',
        'zh_TW.UTF-8': '腫瘤板調度器',
      },
      'description': {
        'en_US.UTF-8': 'This tool will be used by hospital admins to schedule patients, track agenda items, send out alerts to presenters, and perform basic analytics for Tumor Boards.',
        'fr_CA.UTF-8': 'Cet outil sera utilisé par les administrateurs des hôpitaux pour programmer les patients, suivre les points à l’ordre du jour, envoyer des alertes aux présentateurs et effectuer des analyses de base pour les Tumor Boards.',
        'tr_TR.UTF-8': 'Bu araç, hastane yöneticileri tarafından hastaları planlamak, gündem maddelerini takip etmek, sunum yapan kişilere uyarılar göndermek ve Tümör Kurulları için temel analizler yapmak için kullanılacaktır.',
        'zh_CN.UTF-8': '医院管理员将使用此工具来安排患者、跟踪议程项目、向演示者发送警报以及为肿瘤委员会执行基本分析。',
        'zh_TW.UTF-8': '醫院管理員將使用此工具來安排患者、跟踪議程項目、向演示者發送警報以及為腫瘤委員會執行基本分析。',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NzYgNTEyIj48IS0tISBGb250IEF3ZXNvbWUgUHJvIDYuMy4wIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlIChDb21tZXJjaWFsIExpY2Vuc2UpIENvcHlyaWdodCAyMDIzIEZvbnRpY29ucywgSW5jLiAtLT48cGF0aCBkPSJNMTI4IDBjMTMuMyAwIDI0IDEwLjcgMjQgMjRWNjRIMjk2VjI0YzAtMTMuMyAxMC43LTI0IDI0LTI0czI0IDEwLjcgMjQgMjRWNjRoNDBjMzUuMyAwIDY0IDI4LjcgNjQgNjR2MTYgNDhINDMyIDQwMCAyODggNDhWNDQ4YzAgOC44IDcuMiAxNiAxNiAxNkgyODQuNWMxMi4zIDE4LjggMjggMzUuMSA0Ni4zIDQ4SDY0Yy0zNS4zIDAtNjQtMjguNy02NC02NFYxOTIgMTQ0IDEyOEMwIDkyLjcgMjguNyA2NCA2NCA2NGg0MFYyNGMwLTEzLjMgMTAuNy0yNCAyNC0yNHpNMjg4IDM2OGExNDQgMTQ0IDAgMSAxIDI4OCAwIDE0NCAxNDQgMCAxIDEgLTI4OCAwem0xNDQtODBjLTguOCAwLTE2IDcuMi0xNiAxNnY2NGMwIDguOCA3LjIgMTYgMTYgMTZoNDhjOC44IDAgMTYtNy4yIDE2LTE2cy03LjItMTYtMTYtMTZINDQ4VjMwNGMwLTguOC03LjItMTYtMTYtMTZ6Ii8+PC9zdmc+',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {},
        'url': {
          'baseUrl': '/tumor_board/mypatient/v1/',
          'method': 'GET',
          'queryParams': {
          },
        },
      },
    },
    'e5792213-e1a1-4f86-92e3-a242b28fccb3': {
      'id': 'e5792213-e1a1-4f86-92e3-a242b28fccb3',
      'width': 6,
      'height': 4,
      'name': {
        'en_US.UTF-8': 'Clinical Timeline',
        'fr_CA.UTF-8': 'Chronologie Clinique',
        'tr_TR.UTF-8': 'Klinik Zaman Çizelgesi',
        'zh_CN.UTF-8': '临床年表',
        'zh_TW.UTF-8': '臨床年表',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMTYgMTI4aDQxNmM4Ljg0IDAgMTYtNy4xNiAxNi0xNlY4MGMwLTguODQtNy4xNi0xNi0xNi0xNkgxNkM3LjE2IDY0IDAgNzEuMTYgMCA4MHYzMmMwIDguODQgNy4xNiAxNiAxNiAxNnptNDgwIDk2SDgwYy04Ljg0IDAtMTYgNy4xNi0xNiAxNnYzMmMwIDguODQgNy4xNiAxNiAxNiAxNmg0MTZjOC44NCAwIDE2LTcuMTYgMTYtMTZ2LTMyYzAtOC44NC03LjE2LTE2LTE2LTE2em0tNjQgMTYwSDE2Yy04Ljg0IDAtMTYgNy4xNi0xNiAxNnYzMmMwIDguODQgNy4xNiAxNiAxNiAxNmg0MTZjOC44NCAwIDE2LTcuMTYgMTYtMTZ2LTMyYzAtOC44NC03LjE2LTE2LTE2LTE2eiIvPjwvc3ZnPg==',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {
          'neutrophils': '',
          'platelet': '',
          'wbc': '',
        },
        'url': {
          'baseUrl': '/timeline',
          'method': 'GET',
          'queryParams': {
            'birthdate': { 'key': 'birthdate', 'required': true },
            'currentThemeName': { 'key': 'ux2_theme', 'required': true },
            'family': { 'key': 'family', 'required': true },
            'given': { 'key': 'given', 'required': true },
            'language': { 'key': 'language', 'required': true },
            'neutrophils': { 'key': 'neutrophils', 'required': true },
            'patientId': { 'key': 'MRN', 'required': true },
            'platelet': { 'key': 'platelet', 'required': true },
            'toolId': { 'key': 'toolId', 'required': true },
            'wbc': { 'key': 'wbc', 'required': true },
          },
        },
      },
    },
    'ca5d75c6-878d-4184-a807-d33b0ea9a56b': {
      'id': 'ca5d75c6-878d-4184-a807-d33b0ea9a56b',
      'name': {
        'en_US.UTF-8': 'Diagnosis',
        'fr_CA.UTF-8': 'Diagnostic',
        'tr_TR.UTF-8': 'Tanı',
        'zh_CN.UTF-8': '诊断',
        'zh_TW.UTF-8': '診斷',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NDAgNjQwIj48cGF0aCBkPSJNMTY4IDI4OGgxMjh2MzJoLTk2Yy00LjQgMC04IDMuNi04IDh2MTZjMCA0LjQgMy42IDggOCA4aDk2djMyaC01NmMtMjYuNSAwLTQ4IDIxLjUtNDggNDhzMjEuNSA0OCA0OCA0OCA0OC0yMS41IDQ4LTQ4aDY0YzAgMjYuNSAyMS41IDQ4IDQ4IDQ4czQ4LTIxLjUgNDgtNDgtMjEuNS00OC00OC00OGgtNTZ2LTMyaDk2YzQuNCAwIDgtMy42IDgtOHYtMTZjMC00LjQtMy42LTgtOC04aC05NnYtMzJoMTI4YzQuNCAwIDgtMy42IDgtOHYtMTZjMC00LjQtMy42LTgtOC04SDM0NHYtMzJoOTZjNC40IDAgOC0zLjYgOC04di0xNmMwLTQuNC0zLjYtOC04LThoLTk2di00MGMwLTQuNC0zLjYtOC04LThoLTMyYy00LjQgMC04IDMuNi04IDh2NDBoLTk2Yy00LjQgMC04IDMuNi04IDh2MTZjMCA0LjQgMy42IDggOCA4aDk2djMySDE2OGMtNC40IDAtOCAzLjYtOCA4djE2YzAgNC40IDMuNiA4IDggOHptNTYgMTQ0YzAtMjEuMiAzMi0yMS4yIDMyIDBzLTMyIDIxLjEtMzIgMHptMTkyIDBjMCAyMS4yLTMyIDIxLjEtMzIgMCAwLTIxLjIgMzItMjEuMiAzMiAwem0yMTYtMzIwYzQuNCAwIDgtMy42IDgtOFY3MmMwLTQuNC0zLjYtOC04LThIOGMtNC40IDAtOCAzLjYtOCA4djMyYzAgNC40IDMuNiA4IDggOGg1NnY0MTZIOGMtNC40IDAtOCAzLjYtOCA4djMyYzAgNC40IDMuNiA4IDggOGg2MjRjNC40IDAgOC0zLjYgOC04di0zMmMwLTQuNC0zLjYtOC04LThoLTU2VjExMnpNNTI4IDUyOEgxMTJWMTEyaDQxNnoiLz48L3N2Zz4=',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {},
        'url': {
          'baseUrl': '/odaradiology/RadiologyTool',
          'method': 'GET',
          'queryParams': {
            'location': { 'key': 'location', 'required': true },
            'patientId': { 'key': 'patientid', 'required': true },
          },
        },
      },
    },
    'a74923b2-e6cc-48ad-81a7-260bc7beb73b': {
      'id': 'a74923b2-e6cc-48ad-81a7-260bc7beb73b',
      'width': 9,
      'height': 4,
      'name': {
        'en_US.UTF-8': 'Cohort Query',
        'fr_CA.UTF-8': 'Requête de Cohorte',
        'tr_TR.UTF-8': 'Kohort Sorgusu',
        'zh_CN.UTF-8': '队列查询',
        'zh_TW.UTF-8': '隊列查詢',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NDAgNjQwIj48cGF0aCBkPSJNNTQ0LjA1IDI4OGM0NC4yIDAgODAtMzUuOCA4MC04MHMtMzUuOC04MC04MC04MC04MCAzNS44LTgwIDgwIDM1LjggODAgODAgODB6bTAtMTEyYzE3LjYgMCAzMiAxNC40IDMyIDMycy0xNC40IDMyLTMyIDMyLTMyLTE0LjQtMzItMzIgMTQuNC0zMiAzMi0zMnptLTQ0OCAxMTJjNDQuMiAwIDgwLTM1LjggODAtODBzLTM1LjgtODAtODAtODAtODAgMzUuOC04MCA4MCAzNS44IDgwIDgwIDgwem0wLTExMmMxNy42IDAgMzIgMTQuNCAzMiAzMnMtMTQuNCAzMi0zMiAzMi0zMi0xNC40LTMyLTMyIDE0LjQtMzIgMzItMzJ6bTM5Ni40IDIxMC45Yy0yNy41LTQwLjgtODAuNy01Ni0xMjcuOC00MS43LTE0LjIgNC4zLTI5LjEgNi43LTQ0LjcgNi43LTE1LjYgMC0zMC41LTIuNC00NC43LTYuNy00Ny4xLTE0LjMtMTAwLjMuOC0xMjcuOCA0MS43LTEyLjQgMTguNC0xOS42IDQwLjUtMTkuNiA2NC4zVjQ5NmMwIDI2LjUgMjEuNSA0OCA0OCA0OGgyODhjMjYuNSAwIDQ4LTIxLjUgNDgtNDh2LTQ0LjhjLjItMjMuOC03LTQ1LjktMTkuNC02NC4zek00NjQuMDUgNDk2aC0yODh2LTQ0LjhjMC0zNi40IDI5LjItNjYuMiA2NS40LTY3LjIgMjUuNSAxMC42IDUxLjkgMTYgNzguNiAxNiAyNi43IDAgNTMuMS01LjQgNzguNi0xNiAzNi4yIDEgNjUuNCAzMC43IDY1LjQgNjcuMnptOTItMTc2aC0yNGMtMTcuMyAwLTMzLjQgNS4zLTQ2LjggMTQuMyAxMy40IDEwLjEgMjUuMiAyMi4yIDM0LjQgMzYuMiAzLjktMS40IDgtMi41IDEyLjMtMi41aDI0YzE5LjggMCAzNiAxNi4yIDM2IDM2IDAgMTMuMiAxMC44IDI0IDI0IDI0czI0LTEwLjggMjQtMjRjLjEtNDYuMy0zNy42LTg0LTgzLjktODR6bS0yMzYgMGM2MS45IDAgMTEyLTUwLjEgMTEyLTExMnMtNTAuMS0xMTItMTEyLTExMi0xMTIgNTAuMS0xMTIgMTEyIDUwLjEgMTEyIDExMiAxMTJ6bTAtMTc2YzM1LjMgMCA2NCAyOC43IDY0IDY0cy0yOC43IDY0LTY0IDY0LTY0LTI4LjctNjQtNjQgMjguNy02NCA2NC02NHptLTE2NS4yIDE5MC4zYy0xMy40LTktMjkuNS0xNC4zLTQ2LjgtMTQuM2gtMjRjLTQ2LjMgMC04NCAzNy43LTg0IDg0IDAgMTMuMiAxMC44IDI0IDI0IDI0czI0LTEwLjggMjQtMjRjMC0xOS44IDE2LjItMzYgMzYtMzZoMjRjNC40IDAgOC41IDEuMSAxMi4zIDIuNSA5LjMtMTQgMjEuMS0yNi4xIDM0LjUtMzYuMnoiLz48L3N2Zz4=',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {
          'startDate': '2015-01-01',
          'endDate': '2021-12-31',
          'nomenu': 'true',
        },
        'url': {
          'baseUrl': '/NewGenericCohortQuery',
          'method': 'GET',
          'queryParams': {
            'endDate': { 'key': 'date2', 'required': true },
            'language': { 'key': 'language', 'required': true },
            'nomenu': { 'key': 'nomenu', 'required': true },
            'patientId': { 'key': 'MRN', 'required': false },
            'startDate': { 'key': 'date1', 'required': true },
          },
        },
      },
    },
    '185be2d5-4a3f-48b7-bb27-e9e5999ac5bf': {
      'id': '185be2d5-4a3f-48b7-bb27-e9e5999ac5bf',
      'width': 9,
      'height': 4,
      'name': {
        'en_US.UTF-8': 'Genomics',
        'fr_CA.UTF-8': 'Génomique',
        'tr_TR.UTF-8': 'Genomik',
        'zh_CN.UTF-8': '基因组学',
        'zh_TW.UTF-8': '基因組學',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNNjQgNDk1LjFjLS41IDcuOSA1LjIgMTYuOSAxNS40IDE2LjloMTUuNGM4LjEgMCAxNC43LTYuMiAxNS4zLTE0LjQuMy00LjUgMS0xMC41IDIuMi0xNy42aDI4N2MxLjIgNy4xIDIuMSAxMy40IDIuNSAxNy43LjcgOC4xIDcuMyAxNC4zIDE1LjMgMTQuM2gxNS41YzExLjUgMCAxNS44LTEwLjcgMTUuMy0xNi44LTIuMS0yOS41LTE2LjMtMTI2LjgtMTA4LjUtMjA4LjgtMTIuNiA5LjMtMjYuMiAxOC4yLTQwLjkgMjYuNyA5LjEgNy41IDE3IDE1LjIgMjQuNiAyM0gxODcuNmMyMC42LTIwLjkgNDYuNC00MS4zIDc5LjMtNTkuM0M0MjMuOCAxOTAuNSA0NDUuMiA1NiA0NDggMTYuOSA0NDguNSA5IDQ0Mi44IDAgNDMyLjYgMGgtMTUuNGMtOC4xIDAtMTQuNyA2LjItMTUuMyAxNC40LS4zIDQuNS0xIDEwLjUtMi4yIDE3LjZIMTEyLjZjLTEuMy03LjEtMi0xMy4yLTIuNC0xNy43QzEwOS41IDYuMiAxMDIuOSAwIDk0LjkgMEg3OS40QzY5LjIgMCA2My41IDkuMSA2NCAxNi45YzIuNiAzNS43IDIxLjIgMTUzIDE0Ny45IDIzOC45Qzg1LjMgMzQxLjQgNjYuNiA0NTguOSA2NCA0OTUuMXpNMzg2LjQgODBjLTUuNyAxNS0xMy42IDMxLjMtMjQuMiA0OEgxNTAuM2MtMTAuNi0xNi43LTE4LjUtMzMtMjQuMy00OHpNMjU2IDIyOC44Yy0yNy40LTE2LjMtNDkuNC0zNC4zLTY3LjUtNTIuOGgxMzUuNGMtMTguMiAxOC40LTQwLjMgMzYuNC02Ny45IDUyLjh6TTEyNS40IDQzMmM1LjctMTQuOSAxMy41LTMxLjIgMjQuMS00OGgyMTEuN2MxMC42IDE2LjggMTguNiAzMyAyNC40IDQ4eiIvPjwvc3ZnPg==',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {
          'startDate': '2015-01-01',
          'endDate': '2021-12-31',
          'nomenu': 'true',
        },
        'url': {
          'baseUrl': '/GenericAnnotation',
          'method': 'GET',
          'queryParams': {
            'endDate': { 'key': 'date2', 'required': true },
            'language': { 'key': 'language', 'required': true },
            'location': { 'key': 'location', 'required': true },
            'startDate': { 'key': 'date1', 'required': true },
            'nomenu': { 'key': 'nomenu', 'required': false },
            'patientId': { 'key': 'query', 'required': true },
          },
        },
      },
    },
    '483475f9-7165-46bf-ac0b-323adaa9fac9': {
      'id': '483475f9-7165-46bf-ac0b-323adaa9fac9',
      'width': 12,
      'height': 8,
      'name': {
        'en_US.UTF-8': 'Data Summary Display',
        'fr_CA.UTF-8': 'Affichage du Résumé des Données',
        'tr_TR.UTF-8': 'Veri Özeti Ekranı',
        'zh_CN.UTF-8': '数据摘要显示',
        'zh_TW.UTF-8': '數據摘要顯示',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMzk2LjggMzUyaDIyLjRjNi40IDAgMTIuOC02LjQgMTIuOC0xMi44VjEwOC44YzAtNi40LTYuNC0xMi44LTEyLjgtMTIuOGgtMjIuNGMtNi40IDAtMTIuOCA2LjQtMTIuOCAxMi44djIzMC40YzAgNi40IDYuNCAxMi44IDEyLjggMTIuOHptLTE5MiAwaDIyLjRjNi40IDAgMTIuOC02LjQgMTIuOC0xMi44VjE0MC44YzAtNi40LTYuNC0xMi44LTEyLjgtMTIuOGgtMjIuNGMtNi40IDAtMTIuOCA2LjQtMTIuOCAxMi44djE5OC40YzAgNi40IDYuNCAxMi44IDEyLjggMTIuOHptOTYgMGgyMi40YzYuNCAwIDEyLjgtNi40IDEyLjgtMTIuOFYyMDQuOGMwLTYuNC02LjQtMTIuOC0xMi44LTEyLjhoLTIyLjRjLTYuNCAwLTEyLjggNi40LTEyLjggMTIuOHYxMzQuNGMwIDYuNCA2LjQgMTIuOCAxMi44IDEyLjh6TTQ5NiA0MDBINDhWODBjMC04Ljg0LTcuMTYtMTYtMTYtMTZIMTZDNy4xNiA2NCAwIDcxLjE2IDAgODB2MzM2YzAgMTcuNjcgMTQuMzMgMzIgMzIgMzJoNDY0YzguODQgMCAxNi03LjE2IDE2LTE2di0xNmMwLTguODQtNy4xNi0xNi0xNi0xNnptLTM4Ny4yLTQ4aDIyLjRjNi40IDAgMTIuOC02LjQgMTIuOC0xMi44di03MC40YzAtNi40LTYuNC0xMi44LTEyLjgtMTIuOGgtMjIuNGMtNi40IDAtMTIuOCA2LjQtMTIuOCAxMi44djcwLjRjMCA2LjQgNi40IDEyLjggMTIuOCAxMi44eiIvPjwvc3ZnPg==',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {},
        'url': {
          'baseUrl': '/data-summary-bbtool',
          'method': 'GET',
          'queryParams': {
            'currentThemeName': { 'key': 'ux2_theme', 'required': true },
          },
        },
      },
    },
    '30e5f376-7d69-4004-9dff-fab6b67e219d': {
      'id': '30e5f376-7d69-4004-9dff-fab6b67e219d',
      'name': {
        'en_US.UTF-8': 'Pathology',
        'fr_CA.UTF-8': 'Pathologie',
        'tr_TR.UTF-8': 'Patoloji',
        'zh_CN.UTF-8': '病理学',
        'zh_TW.UTF-8': '病理學',
      },
      'description': {
        'en_US.UTF-8': '',
        'fr_CA.UTF-8': '',
        'tr_TR.UTF-8': '',
        'zh_CN.UTF-8': '',
        'zh_TW.UTF-8': '',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNNDc2IDQ2NGgtNDAuNWMzNy4wNi0zMy42OCA2MC41LTgyLjEgNjAuNS0xMzYgMC05OC43NS03OC4yNi0xNzkuMzYtMTc2LTE4My42Vjk3LjE0YzAtMTguMzktMTAuMTYtMzQuNDUtMjUuMTYtNDIuODhWMzYuNThjMC0yMC4xNy0xNi40LTM2LjU4LTM2LjU2LTM2LjU4SDE1Ny43MmMtMjAuMTYgMC0zNi41NiAxNi40MS0zNi41NiAzNi41OHYxNy42OUMxMDYuMTYgNjIuNjkgOTYgNzguNzUgOTYgOTcuMTR2MTk3LjcyYzAgMjIuMDIgMTQuNTYgNDAuNyAzNC41NiA0Ni45NHYzNy42MmMwIDIwLjE3IDE2LjQxIDM2LjU4IDM2LjU5IDM2LjU4aDgxLjY5YzIwLjE5IDAgMzYuNTktMTYuNDEgMzYuNTktMzYuNThWMzQxLjhjMjAtNi4yMyAzNC41Ni0yNC45MiAzNC41Ni00Ni45NFYxOTIuODFjNzEuMjEgNC4yMyAxMjggNjIuOTUgMTI4IDEzNS4xOSAwIDc0Ljk4LTYxIDEzNi0xMzYgMTM2SDM2Yy0xOS44OCAwLTM2IDE2LjEyLTM2IDM2IDAgNi42MyA1LjM3IDEyIDEyIDEyaDQ4OGM2LjYzIDAgMTItNS4zNyAxMi0xMiAwLTE5Ljg4LTE2LjEyLTM2LTM2LTM2em0tMjk3LjQ0LTk2di00MGg1OC44OHY0MGgtNTguODh6bTkyLjI4LTcySDE0NS4xNmwtMS4xNi0xLjE0TDE0NS4xNiA5NmgyNFY0OGg3Ny42OUwyNDggOTZoMjRsLTEuMTYgMjAweiIvPjwvc3ZnPg==',
      'componentName': 'BlackBoxSSRTool',
      'payload': {
        'data': {},
        'url': {
          'baseUrl': pathologyViewerRoute,
          'method': 'GET',
          'queryParams': {
            'patientIds': { 'key': 'patient_identifier', 'required': true },
          },
        },
      },
    },
    'e60a37a0-cd6c-48ec-983c-efc53c973d73': {
      'id': 'e60a37a0-cd6c-48ec-983c-efc53c973d73',
      'componentName': 'BlackBoxSSRTool',
      'name': {
        'en_US.UTF-8': 'Federated Analysis Tool',
        'fr_CA.UTF-8': 'Federated Analysis Tool',
        'tr_TR.UTF-8': 'Federated Analysis Tool',
        'zh_CN.UTF-8': 'Federated Analysis Tool',
        'zh_TW.UTF-8': 'Federated Analysis Tool',
      },
      'svgIconBase64': 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NDAgNjQwIj48cGF0aCBkPSJNMzM2IDUzNlYzNDRoNDh2LTQ4aC00OFYxMDRoNDhWNTZoLTU3LjU5QzMwNS4yNCA1NiAyODggNzMuMjIgMjg4IDk0LjQxVjI5NmgtNjR2LTQwYzAtMTcuNjctMTQuMzMtMzItMzItMzJIOTZjLTE3LjY3IDAtMzIgMTQuMzMtMzIgMzJ2MTI4YzAgMTcuNjcgMTQuMzMgMzIgMzIgMzJoOTZjOC44NCAwIDE2Ljg0LTMuNTggMjIuNjMtOS4zNyA1Ljc5LTUuNzkgOS4zNy0xMy43OSA5LjM3LTIyLjYzdi00MGg2NHYyMDEuNTljMCAyMS4xOSAxNy4yMyAzOC40MSAzOC40MSAzOC40MUgzODR2LTQ4ek0xNzYgMzY4aC02NHYtOTZoNjR6TTQxNiAzMnY5NmMwIDE3LjY3IDE0LjMzIDMyIDMyIDMyaDk2YzE3LjY3IDAgMzItMTQuMzMgMzItMzJWMzJjMC0xNy42Ny0xNC4zMy0zMi0zMi0zMmgtOTZjLTE3LjY3IDAtMzIgMTQuMzMtMzIgMzJ6bTExMiAxNnY2NGgtNjRWNDh6TTQxNiAyNzJ2OTZjMCAxNy42NyAxNC4zMyAzMiAzMiAzMmg5NmMxNy42NyAwIDMyLTE0LjMzIDMyLTMydi05NmMwLTE3LjY3LTE0LjMzLTMyLTMyLTMyaC05NmMtMTcuNjcgMC0zMiAxNC4zMy0zMiAzMnptMTEyIDE2djY0aC02NHYtNjR6TTQxNiA1MTJ2OTZjMCAxNy42NyAxNC4zMyAzMiAzMiAzMmg5NmMxNy42NyAwIDMyLTE0LjMzIDMyLTMydi05NmMwLTE3LjY3LTE0LjMzLTMyLTMyLTMyaC05NmMtMTcuNjcgMC0zMiAxNC4zMy0zMiAzMnptMTEyIDE2djY0aC02NHYtNjR6Ii8+PC9zdmc+',
      'payload': {
        'data': {},
        'url': {
          'baseUrl': '/federation/FederatedAnalysisFrontend',
          'method': 'GET',
          'queryParams': {},
        },
      },
    },
    'e70665c9-9206-40db-a2e4-9f5bf54fa9e8': {
      'id': 'e70665c9-9206-40db-a2e4-9f5bf54fa9e8',
      'componentName': 'BlackBoxSSRTool',
      'name': {
        'en_US.UTF-8': 'Treatments/Trials Search',
        'fr_CA.UTF-8': 'Treatments/Trials Search - TBD',
        'tr_TR.UTF-8': 'Treatments/Trials Search - TBD',
        'zh_CN.UTF-8': 'Treatments/Trials Search - TBD',
        'zh_TW.UTF-8': 'Treatments/Trials Search - TBD',
      },
      'payload': {
        'data': {},
        'url': {
          'baseUrl': '/odaMolecularMatchSearch',
          'method': 'GET',
          'queryParams': {},
        },
      },
    },
  },
  'researcher': {},
}

export const defaultUPennSessionTools = [
  {
    'id': '9e135e0a-0382-4b62-bbb5-ce95c90b1e00',
    'name': { 'en_US.UTF-8': 'Image Viewer', 'fr_CA.UTF-8': 'Image Viewer - TBD', 'tr_TR.UTF-8': 'Image Viewer - TBD', 'zh_CN.UTF-8': 'Image Viewer - TBD', 'zh_TW.UTF-8': 'Image Viewer - TBD' },
    'description': { 'en_US.UTF-8': '', 'fr_CA.UTF-8': '', 'tr_TR.UTF-8': '', 'zh_CN.UTF-8': '', 'zh_TW.UTF-8': '' },
    'componentName': 'BlackBoxSSRTool',
    'payload': {
      'data': {},
      'url': {
        'baseUrl': '/pathds/viewer/v1/thumbnails',
        'method': 'GET',
        'queryParams': {
        },
      },
    },
    'col': 2, 'row': 0, 'width': 8, 'height': 7,
  },
  {
    'id': '60f7e489-86ea-474e-b3ee-6e5e0624a30d',
    'name': {
      'en_US.UTF-8': 'Navigation',
      'fr_CA.UTF-8': 'Navigation - TBD',
      'tr_TR.UTF-8': 'Navigation - TBD',
      'zh_CN.UTF-8': 'Navigation - TBD',
      'zh_TW.UTF-8': 'Navigation - TBD',
    },
    'description': { 'en_US.UTF-8': '', 'fr_CA.UTF-8': '', 'tr_TR.UTF-8': '', 'zh_CN.UTF-8': '', 'zh_TW.UTF-8': '' },
    'componentName': 'BlackBoxSSRTool',
    'payload': {
      'data': {},
      'url': {
        'baseUrl': '/radiology-thumbnails',
        'method': 'GET',
        'queryParams': {
        },
      },
    },
    'col': 0, 'row': 0, 'width': 2, 'height': 7,
  },
  {
    'id': '21dadb0f-d6a8-4f24-90db-a4c0b4054017',
    'name': {
      'en_US.UTF-8': 'Annotation',
      'fr_CA.UTF-8': 'Annotation - TBD',
      'tr_TR.UTF-8': 'Annotation - TBD',
      'zh_CN.UTF-8': 'Annotation - TBD',
      'zh_TW.UTF-8': 'Annotation - TBD',
    },
    'description': { 'en_US.UTF-8': '', 'fr_CA.UTF-8': '', 'tr_TR.UTF-8': '', 'zh_CN.UTF-8': '', 'zh_TW.UTF-8': '' },
    'componentName': 'BlackBoxSSRTool',
    'payload': {
      'data': {},
      'url': {
        'baseUrl': '/radiology-annotation',
        'method': 'GET',
        'queryParams': {
        },
      },
    },
    'col': 10, 'row': 0, 'width': 2, 'height': 7,
  },
]
